import { Box, Stack, Typography } from "@mui/material";
import { CoreButton } from "@verity/components/core";
import i18n from "../../../../../../i18n";
import { getPlatformLabel } from "../../../utils";
import { ExportIcon } from "../../assets";
import { CandidateOptionsType } from "../../types";
import { Clock } from "./assets";
import InfoCard from "./components/InfoCard";
import styles from "./WaitingPage.module.css";

type WaitingPageProps = {
	candidateOptions: CandidateOptionsType;
};

export default function WaitingPage({ candidateOptions }: WaitingPageProps) {
	if (!candidateOptions) return null;

	return (
		<div className={styles.body}>
			<Stack gap="80px">
				<InfoCard>{i18n.t("candidate.instructorInterviewPage.waiting.message")}</InfoCard>

				<Stack gap="25px" alignItems="center">
					<Box>
						<img src={Clock} />
					</Box>

					<Typography className={styles.waitingHeader}>
						{i18n.t("candidate.instructorInterviewPage.waiting.title")}
					</Typography>
					<Typography className={styles.waitingDescription}>
						{i18n.t("candidate.instructorInterviewPage.waiting.description")}
					</Typography>
					<CoreButton
						endIcon={<ExportIcon />}
						onClick={() => window.open(candidateOptions.meetingLink, "_blank")}
						style={{ padding: "8px 15px" }}
					>
						{i18n.t("candidate.instructorInterviewPage.waiting.launchCall", {
							videoPlatform: getPlatformLabel(candidateOptions.videoPlatform),
						})}
					</CoreButton>
				</Stack>
			</Stack>
		</div>
	);
}
